export default function MailButton() {
  const email = 'support@tredextechnology.in'

  return (
    <a
      href={`mailto:${email}`}
      className="mail-float"
      aria-label="Email us"
    >
      <i className="fas fa-envelope"></i>
    </a>
  )
}